import { useMemo } from "react";
import { useApolloNetworkStatus } from "@apolloClient/client";

/**
 * Gets the global loading state based on the number of pending apollo queries.
 *
 * @returns - Global loading state.
 */
export function useGlobalLoading() {
  const status = useApolloNetworkStatus();
  const loading = useMemo(() => status.numPendingMutations > 0, [status]);

  return { loading };
}
